import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import FormElement from '@wix/da-ds/pkg/formControls/layouts/FormElement';
import InputLabelText from '@wix/da-ds/pkg/formControls/lego/InputLabelText';
import InputErrorMessage from '@wix/da-ds/pkg/formControls/lego/InputErrorMessage';
import DescriptionEditor from '@wix/da-shared-react/pkg/DescriptionEditor';

interface Props {}

const DescriptionField: React.FC<Props> = () => {
  const { t } = useTranslation();
  const id = useId();
  const { control, errors } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({ name: 'description', control });
  const error = errors['description'];

  return (
    <FormElement
      inputId={id}
      label={
        <InputLabelText isRequired>
          {t('customExclusivePopup.form.description.label')}
        </InputLabelText>
      }
      noBottomSpacing
    >
      <DescriptionEditor
        placeholder={t('customExclusivePopup.form.description.placeholder')}
        initialContent={value}
        onChange={onChange}
      />
      {error && <InputErrorMessage>{error.message}</InputErrorMessage>}
    </FormElement>
  );
};
DescriptionField.displayName = 'DescriptionField';

export default DescriptionField;
